if (typeof debounce === "undefined") {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
/**
 *  @class
 *  @function ThemeHeader
 */

if (!customElements.get("theme-header")) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header_section = document.querySelector(".header-section");
      this.menu = this.querySelector("#mobile-menu");
      this.toggle = this.querySelector(".mobile-toggle-wrapper");
      this.toggle_secondary = this.querySelectorAll(".mobile-toggle_secondary-wrapper");
      this.announcement_bar_section = document.querySelector(".announcement-bar-section");
      this.open_modal = document.querySelector(".mobile-open-search-modal");
      
      this.all_elements_should_be_toggle_hidden = this.querySelectorAll("#hidden-active-mobile-header");

      document.addEventListener("keyup", (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === "ESCAPE") {
            this.toggle.removeAttribute("open");
            this.toggle.classList.remove("active");
            if (this.announcement_bar_section) {
              this.announcement_bar_section.classList.remove("hidden");
            }

            if (this.open_modal) {
              this.open_modal.classList.remove("hidden");
            }
          }
        }
      });
      if (this.classList.contains("header-sticky--active")) {
        document.body.classList.add("header-sticky--active");
      }
      const mobileToggleButton = this.toggle?.querySelector(".mobile-toggle");
      if (mobileToggleButton) {
        mobileToggleButton.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          if (this.toggle.classList.contains("active")) {
            // document.body.classList.remove("!overflow-hidden");
            document.body.style.overflow = "";
            this.toggle.classList.remove("active");
            this.toggle.removeAttribute("open");
            if (this.announcement_bar_section && this.announcement_bar_section.classList.contains("hidden")) {
              this.announcement_bar_section.classList.remove("hidden");
            }

            if (this.open_modal && this.open_modal.classList.contains("hidden")) {
              this.open_modal.classList.remove("hidden");
            }
            if (this.all_elements_should_be_toggle_hidden && this.all_elements_should_be_toggle_hidden.length) {
              this.all_elements_should_be_toggle_hidden.forEach((xElement) => {
                if (xElement.classList.contains("!hidden")) {
                  xElement.classList.remove("!hidden");
                }
              });
            }
            this.closeAnimation(this.toggle);
          } else {
            // document.body.classList.add("!overflow-hidden");
            document.body.style.overflow = "hidden";
            this.toggle.setAttribute("open", "");
            setTimeout(() => {
              this.toggle.classList.add("active");

            if (this.toggle_secondary && this.toggle_secondary.length) {
              this.toggle_secondary.forEach((xElementWrapper) => {
                xElementWrapper.classList.add("active");
                xElementWrapper.setAttribute("open", "");
              });
            }

              if (this.announcement_bar_section) {
                this.announcement_bar_section.classList.add("hidden");
              }

              if (this.all_elements_should_be_toggle_hidden && this.all_elements_should_be_toggle_hidden.length) {
                this.all_elements_should_be_toggle_hidden.forEach((xElement) => {
                  // Don't hide wishlist and my bag icons (thb-secondary-area)
                  // Also don't hide the menu toggle button itself
                  // Check if element has the class or is inside thb-secondary-area
                  if (xElement.classList.contains('thb-secondary-area') || 
                      xElement.classList.contains('mobile-toggle') ||
                      xElement.closest('.thb-secondary-area')) {
                    return;
                  }
                  xElement.classList.add("!hidden");
                });
              }

              if (this.open_modal) {
                this.open_modal.classList.add("hidden");
              }
            }, 0);
          }
        });
      }

      this.toggle_secondary.forEach((xElementWrapper) => {
        const secondaryToggleButton = xElementWrapper.querySelector(".mobile-toggle_secondary");

        if (secondaryToggleButton) {
          secondaryToggleButton.addEventListener("click", (e) => {
            if (xElementWrapper.classList.contains("active")) {
              e.preventDefault();
              // document.body.classList.remove("!overflow-hidden");
              document.body.style.overflow = "";
              xElementWrapper.classList.remove("active");
              this.toggle.classList.remove("active");
              this.toggle.classList.remove("hidden");

              if (this.announcement_bar_section && this.announcement_bar_section.classList.contains("hidden")) {
                this.announcement_bar_section.classList.remove("hidden");
              }

              if (this.open_modal && this.open_modal.classList.contains("hidden")) {
                this.open_modal.classList.remove("hidden");
              }

              if (this.all_elements_should_be_toggle_hidden && this.all_elements_should_be_toggle_hidden.length) {
                this.all_elements_should_be_toggle_hidden.forEach((xElement) => {
                  if (xElement.classList.contains("!hidden")) {
                    xElement.classList.remove("!hidden");
                  }
                });
              }

              this.closeAnimation(this.toggle);
              this.closeAnimation(xElementWrapper);
            }
          });
        }
      });

      this.setHeaderOffset();
      this.setHeaderHeight();

      let frameScheduled = false;

      // Sticky Header Class
      window.addEventListener("scroll", () => {
        if (frameScheduled) {
          return;
        }

        frameScheduled = true;

        requestAnimationFrame(() => {
          frameScheduled = false;

          this.setStickyClass();
        });
      }, {
        passive: true,
      });
      window.addEventListener("resize", () => {
        if (frameScheduled) {
          return;
        }

        frameScheduled = true;

        requestAnimationFrame(() => {
          frameScheduled = false;

          this.setHeaderOffset();
          this.setHeaderHeight();
        });
      }, {
        passive: true,
      });

      window.dispatchEvent(new Event("scroll"));

      if (document.querySelector(".announcement-bar-section")) {
        window.addEventListener("scroll", this.setAnnouncementHeight(), {
          passive: true,
        });
        window.dispatchEvent(new Event("resize"));
      }

      // Mobile Navigation transparent header support.
      setTimeout(() => {
        this.mobile_nav = document.querySelector(".header-mobile-navigation");

        if (this.mobile_nav && this.classList.contains("transparent--true")) {
          this.mobile_nav.classList.add("is-fixed");
        }
      }, 100);
      // Buttons.
      this.menu.querySelectorAll("summary").forEach((summary) => summary.addEventListener("click", this.onSummaryClick.bind(this)));
      this.menu.querySelectorAll(".parent-link-back--button").forEach((button) => button.addEventListener("click", this.onCloseButtonClick.bind(this)));
    }
    setStickyClass() {
      if (this.classList.contains("header-sticky--active")) {
        let offset = parseInt(this.getBoundingClientRect().top, 10) + document.documentElement.scrollTop;
        this.classList.toggle("is-sticky", window.scrollY >= offset && window.scrollY > 0);
      }
    }
    setAnnouncementHeight() {
      const a_bar = document.querySelector(".announcement-bar-section");
      let h = a_bar.clientHeight;
      document.documentElement.style.setProperty("--announcement-height", h + "px");
    }
    setHeaderOffset() {
      let h = this.header_section.getBoundingClientRect().top;
      document.documentElement.style.setProperty("--header-offset", h + "px");
    }
    setHeaderHeight() {
      let h = this.clientHeight;
      document.documentElement.style.setProperty("--header-height", h + "px");
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest(".link-container");
      const isOpen = detailsElement.hasAttribute("open");
      if (this.querySelector(".parent-link-back--button")) {
        this.menu.scrollTop = 0;
      }
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
      }, 100);
    }
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest("details");
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove("menu-opening");
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute("open");
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }
  customElements.define("theme-header", ThemeHeader);
}

/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get("full-menu")) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();

      this.submenus = this.querySelectorAll(".thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu");
    }
    connectedCallback() {
      if (!this.submenus.length) {
        return;
      }
      const _this = this;
      // resize on initial load
      document.fonts.ready.then(function () {
        window.addEventListener(
          "resize",
          debounce(function () {
            _this.resizeSubMenus();
          }, 100)
        );
      });
    }
    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(":scope >.menu-item-has-children>.sub-menu");

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l = sub_submenu.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.offsetWidth,
            total = w + l;

          if (total > window.innerWidth) {
            sub_submenu.parentElement.classList.add("left-submenu");
          } else if (sub_submenu.parentElement.classList.contains("left-submenu")) {
            sub_submenu.parentElement.classList.remove("left-submenu");
          }
        });
      });
    }
  }
  customElements.define("full-menu", FullMenu);
}
